import moment from "moment";
import { formatGoodsDescriptionDisplay } from "../goodsDescription";

/** DD-MM-YY like the reference document */
export function formatShortDate(value) {
  if (!value) return "—";
  const m = moment(value);
  return m.isValid() ? m.format("DD-MM-YY") : "—";
}

export function formatAmountTaka(value) {
  const n = Number(value) || 0;
  return `${n.toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
}

export function formatLcNoImport(importInvoice) {
  if (!importInvoice) return "—";
  const lc = importInvoice.import_lc_number;
  const sc = importInvoice.sales_contract_number;
  if (lc !== undefined && lc !== null && lc !== "") return String(lc);
  if (sc !== undefined && sc !== null && sc !== "") return String(sc);
  return "—";
}

export function formatLcNoExport(exportInvoice) {
  if (!exportInvoice) return "—";
  if (exportInvoice.exp_number) return String(exportInvoice.exp_number);
  if (exportInvoice.sales_contract_id != null)
    return String(exportInvoice.sales_contract_id);
  return "—";
}

export function formatQuantityImport(importInvoice) {
  if (!importInvoice) return "—";
  const parts = [];
  const qCtn = importInvoice.quantity_ctn;
  const unitImp = importInvoice.import_quantity_unit;
  if (qCtn != null && String(qCtn).trim() !== "" && Number(qCtn) !== 0) {
    parts.push(`${qCtn} ${unitImp || ""}`.trim());
  }
  const qYds = importInvoice.quantity_yds;
  const unitInv = importInvoice.invoice_quantity_unit;
  if (qYds != null && String(qYds).trim() !== "" && Number(qYds) !== 0) {
    parts.push(`${qYds} ${unitInv || ""}`.trim());
  }
  return parts.length ? parts.join(" / ") : "—";
}

export function formatQuantityExport(exportInvoice) {
  if (!exportInvoice) return "—";
  const parts = [];
  const tq = exportInvoice.total_quantity;
  const cq = exportInvoice.carton_quantity;
  if (tq != null && Number(tq) !== 0) {
    parts.push(`${tq} Pcs`);
  }
  if (cq != null && Number(cq) !== 0) {
    parts.push(`${cq} Ctn`);
  }
  return parts.length ? parts.join(" / ") : "—";
}

export function formatGoodsDescription(raw) {
  const label = formatGoodsDescriptionDisplay(raw);
  if (!label) return "—";
  return label.length > 120 ? `${label.slice(0, 117)}…` : label;
}
